export default __webpack_public_path__ + "static/kim-hoetjes-652f0d739d0b11dd828301cfc10c0a90.png";